module.exports = __webpack_public_path__ + "static/media/ecosystem-third.968f131b.jpg";